import setScrollTargetPath from './set-scroll-target-path';
import clearScrollTargetPath from './clear-scroll-target-path';

export default {
  setScrollTargetPath,
  clearScrollTargetPath,
};
